export default "__VITE_ASSET__c9i1KhcO__"